import * as tslib_1 from "tslib";
var CODE = 'UnauthorizedUser';
var UnauthorizedUserError = /** @class */ (function (_super) {
    tslib_1.__extends(UnauthorizedUserError, _super);
    function UnauthorizedUserError() {
        var _this = _super.call(this, CODE) || this;
        _this['error'] = { code: CODE };
        return _this;
    }
    return UnauthorizedUserError;
}(Error));
export { UnauthorizedUserError };
